import { Component } from '@angular/core';
import { FullScreenSpinnerService } from './core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(public spinner: FullScreenSpinnerService) { }
}
